import { applicationRoles } from '../constants/actionTypes'

export const SetApplicationRole = (role) => {
  switch (role) {
    case applicationRoles.USER_ACCEPTED_ESTIMATE:
      return {
        type: applicationRoles.USER_ACCEPTED_ESTIMATE,
      }
    case applicationRoles.USER_WITH_ESTIMATES:
      return {
        type: applicationRoles.USER_WITH_ESTIMATES,
      }
    case applicationRoles.USER_WITH_PROPOSAL_SETUP:
      return {
        type: applicationRoles.USER_WITH_PROPOSAL_SETUP,
      }
    case applicationRoles.USER_WITH_PROPOSAL_ACCEPTED:
      return {
        type: applicationRoles.USER_WITH_PROPOSAL_ACCEPTED,
      }
    case applicationRoles.CONSULTANT:
      return {
        type: applicationRoles.CONSULTANT,
      }
    case applicationRoles.CUSTOMER:
      return {
        type: applicationRoles.CUSTOMER,
      }
  }
}
